//#region src/components/internal/get-hc-prop.ts
const getHcProp = (color) => {
	if (color === "high-contrast") return { "data-high-contrast": "true" };
	if (color === "high-contrast-inverted") return { "data-high-contrast": "inverted" };
	return {};
};

//#endregion
export { getHcProp };